import {
  XesLoadingState
} from "../../reducers/project-state";
import {
  validateCode
} from '../../lib/xes/xes'
import hooks from './hooks'
import message from "antd/lib/message/index";
import {
  toggleSaveLoading
} from '../../components/operation-panel/operation-panel-button/save'
import {
  toggleSubmitLoading
} from '../../components/operation-panel/operation-panel-button/submit'
// import {
//   toggleCheckDisabled
// } from '../../components/operation-panel/operation-panel-button/check'
import {
  toggleExitDisabled
} from '../../components/operation-panel/operation-panel-button/exit'
import {
  toggleCheckLoading
} from '../../components/operation-panel/operation-panel-button/check'

class XesEventHandler {
  constructor(xesHandler) {
    this.params = {}
    this.handlers = null
    this.xesHandler = xesHandler
    this.initHandlers()
  }
  initHandlers() {
    this.handlers = {
      [XesLoadingState.XES_SAVING]: {
        before() {
          toggleSaveLoading(true)
          hooks.fireHook(hooks.types.BEFORE_SAVE)
        },
        after(data) {
          hooks.fireHook(hooks.types.AFTER_SAVE, data)
        },
        success() {
          toggleSaveLoading(false)
          message.success("保存成功")
        },
        fail(e) {
          toggleSaveLoading(false)
          // message.success("保存失败,请重试")
        },
        handle: this.xesHandler.save
      },
      [XesLoadingState.XES_SAVING_AS]: {
        before() {},
        after() {},
        success() {
          message.success("另保存成功")
        },
        fail(e) {
          // message.success("另保存失败,请重试")
        },
        handle: this.xesHandler.saveAs
      },
      [XesLoadingState.XES_SUBMITING]: {
        before() {
          toggleSubmitLoading(true)
          // toggleCheckDisabled(true)
          toggleExitDisabled && toggleExitDisabled(true)
          hooks.fireHook(hooks.types.BEFORE_SUBMIT)
        },
        after(data) {
          hooks.fireHook(hooks.types.AFTER_SUBMIT, data)
        },
        success() {
          toggleSubmitLoading(false)
          // toggleCheckDisabled(false)
          // toggleExitDisabled(false)
          message.success("提交成功")
        },
        fail(e) {
          toggleSubmitLoading(false)
          // toggleCheckDisabled(false)
          toggleExitDisabled && toggleExitDisabled(false)
          message.error("提交失败,请重试")
        },
        handle: this.xesHandler.submit,
      },
      [XesLoadingState.XES_RESET]: {
        before() {},
        after() {},
        success() {},
        fail(e) {},
        handle: this.xesHandler.reset
      },
      [XesLoadingState.XES_CHECKING]: {
        before() {
          toggleCheckLoading(true)
        },
        after(data) {
          hooks.fireHook(hooks.types.AFTER_CHECK, data)
        },
        success() {
          toggleCheckLoading(false)
        },
        fail(e) {
          toggleCheckLoading(false)
          message.error("检查失败")
        },
        handle: this.xesHandler.check
      },
      [XesLoadingState.XES_CHECKING_BACKGROUND]: {
        before() {},
        after(data) {
          hooks.fireHook(hooks.types.AFTER_CHECK_BACKGROUND, data)
        },
        success() {},
        fail(e) {
          hooks.fireHook(hooks.types.AFTER_CHECK_BACKGROUND, null);
          // message.error("检查失败 AFTER_CHECK_BACKGROUND")
        },
        handle: this.xesHandler.check
      }
    }
  }
  handle(loadingState, params) {
    if (!XesLoadingState.hasOwnProperty(loadingState)) {
      return
    }
    const handler = this.handlers[loadingState]
    return validateCode(params.xml)
      .then(() => {
        handler.before()
        return handler['handle'](params)
          .then((data) => {
            handler.success()
            handler.after(data)
            return data
          })
          .catch((e) => {
            console.log('error', e)
            handler.fail(e)
          })
      })
      .catch((e) => {
        console.log('xes-event-handler', loadingState, 'err', e)
      })
  }
}

export default XesEventHandler